const backendUrl = "https://chalfal-backend.herokuapp.com"; //"http://localhost:3005";

export default backendUrl;
